import { useEffect, useState } from "react"

import { REGIONS_TYPE } from "../../utils/constants"
import { useDispatch } from "react-redux"
import { callApiAction } from "../../store/actions/commonAction"
import DashboardListUi from "./DashboardListUi"
import { getDashboardApi } from "../../apis/dashboard.api"

const DashboardController = () => {

    const dispatch = useDispatch()
    const [filters, setFilters] = useState({
        pageNo: 1,
        pageSize: 10,
        search: '',
        searchable: ['name'],
        sort: '',
        type: REGIONS_TYPE.COUNTRY,
        isDropDown:true,
        _id:null,
        camp:null,
        sortDirection: 1,
        product: null,
        country: "India",
        state: null,
        district: null,
    })
    const [loading, setLoading] = useState(false)
    const [list, setList] = useState({})
    const fetchList = () => {
        setLoading(true)
        dispatch(callApiAction(
            async () => await getDashboardApi({ ...filters }),
            (response) => {
                setList(response)
                setLoading(false)
            },
            (err) => {
                setLoading(false)
            }
        ))
    }
    useEffect(() => {
        fetchList()
    }, [filters])

    return <DashboardListUi
        filters={filters}
        setFilters={setFilters}
        loading={loading}
        list={list}
    />
}
export default DashboardController

